import { useMutation } from "urql";

import { CreateCustomerDirectorInfoDocument } from "../../../graphql/generated.ts";

export const useCreateCustomerDirectorInfo = () =>
  useMutation(CreateCustomerDirectorInfoDocument);
